import Vue from "vue";
import Vuetify from "vuetify/lib/framework";

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: "mdi",
  },
  theme: {
    dark: false,
    themes: {
      light: {
        primary: "#ED1A3B",
        secondary: "#194A95",
        accent: "#194A95",
        error: "#5E4EF6",
        info: "#ED1A3B",
        success: "#991CD3",
        warning: "#2BA681",
        leftPanel: "#F2F2F2",
        rightPanel: "#ffffff",
        textColor: "#000000",
        textColorLeft: "#000000",
        spec: "#003895",
      },
      dark: {
        primary: "#ED1A3B",
        secondary: "#194A95",
        accent: "#194A95",
        error: "#5E4EF6",
        info: "#ED1A3B",
        success: "#991CD3",
        warning: "#2BA681",
        leftPanel: "#607D8B",
        rightPanel: "#000000",
        textColor: "#ffffff",
        textColorLeft: "#ffffff",
        spec: "#FFEA00",
      },
    },
  },
});
